/*
  Season partners band (client, 2026-10-07). Sits under the Ultimate Lap hero.
  Client, 2026-10-08: rendered through the shared LogoRail - the exact same
  marquee as the landing "Brands we've worked with" rail (that one never
  glitched; this one did). Full-viewport, label centred above, white logos on
  black. Sizes live in ultimate-lap.css (.gm-pband .gm-rail__item img).
*/
import { LogoRail } from "./LogoRail";

// Client, 2026-10-08: Akaria + Akaari are no longer season partners (they stay
// in the landing "Brands we've worked with"). Pixel Co added. Client,
// 2026-10-22: Paint Protection Solutions (PPS) out - no longer a sponsor.
// This list also drives the Season Partners grid in the footer.
export const SEASON_PARTNERS = [
  { src: "/brand/sponsors/pirelli.webp", name: "Pirelli" },
  { src: "/brand/sponsors/atmoic.webp", name: "Atomic" },
  { src: "/brand/sponsors/mission-motorsport.webp", name: "Mission Motorsport" },
  { src: "/brand/sponsors/pixelco.webp", name: "Pixel Co" },
];

export function PartnersBand({ logos = SEASON_PARTNERS, label = "Season partners", speed = 22, testid = "partners-band" }) {
  return (
    <section className="gm-pband" data-testid={testid} aria-label={label}>
      <div className="gm-pband__inner">
        <div className="container-gm">
          <div className="eyebrow gm-pband__label" data-testid={`${testid}-label`}>{label}</div>
        </div>
        <LogoRail logos={logos} speed={speed} className="gm-rail--dark" testid={`${testid}-rail`} label={label} />
      </div>
    </section>
  );
}
